<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Gestione Area Compagnia Spettacolo', active: true }]"></app-breadcrumb-backoffice>
</section>

<app-accredito-backoffice *ngIf="!loading" [spettacolo]="spettacolo" [evento]="evento"></app-accredito-backoffice>
<app-loading-backoffice [visible]="loading"></app-loading-backoffice>